import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MenuBookIcon from '@material-ui/icons/MenuBook';

const KNOWLEDGE_BASE_LINKS: { label: string; url: string }[] = [
  {
    label: 'Project Setup and Admin',
    url:
      'https://scribehow.com/o/ywZXFERUQuWbNyBhMaZ7rg/page/Project_Setup_and_Admin__6adjZFW_TjGifDiKDGe2ew?referrer=documents',
  },
  {
    label: 'Email',
    url:
      'https://scribehow.com/o/ywZXFERUQuWbNyBhMaZ7rg/page/Email__QJ7E9vQYQH6lWtJYMiXJQg?referrer=documents',
  },
  {
    label: 'Design',
    url:
      'https://scribehow.com/o/ywZXFERUQuWbNyBhMaZ7rg/page/Design__DaZrpBzQSGeER7sBRhyNyw?referrer=documents',
  },
  {
    label: 'Bidding',
    url:
      'https://scribehow.com/o/ywZXFERUQuWbNyBhMaZ7rg/page/Bidding__5hTOSIaeSlKxlqvmHef8YA?referrer=documents',
  },
  {
    label: 'Construction Administration',
    url:
      'https://scribehow.com/o/ywZXFERUQuWbNyBhMaZ7rg/page/Construction_Administration_Scribes__13ND-FJ1RGW8lKY05rRTLQ?referrer=documents',
  },
  {
    label: 'Close Out',
    url:
      'https://scribehow.com/o/ywZXFERUQuWbNyBhMaZ7rg/page/Close_Out__n23adM61Tku3VmhyPiynhQ?referrer=documents',
  },
];

export default function HowToButton() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [knowledgeBaseAnchorEl, setKnowledgeBaseAnchorEl] = React.useState<HTMLElement | null>(
    null,
  );

  const closeAll = () => {
    setKnowledgeBaseAnchorEl(null);
    setAnchorEl(null);
  };

  // Hover opens the secondary menu on desktop; the same handler runs on click so a tap opens it
  // on touch devices, where there is no hover.
  const openKnowledgeBase = (event: React.MouseEvent<HTMLElement>) => {
    setKnowledgeBaseAnchorEl(event.currentTarget);
  };

  const handleLinkClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    closeAll();
  };

  return (
    <>
      <IconButton
        aria-label="how to"
        aria-controls={anchorEl ? 'how-to-menu' : undefined}
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        style={{ padding: 4 }}
      >
        <MenuBookIcon style={{ color: '#7A797A' }} />
        <span style={{ position: 'absolute', fontSize: '12px', top: 25, whiteSpace: 'nowrap' }}>
          HOW TO
        </span>
      </IconButton>

      <Menu
        id="how-to-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeAll}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ style: { maxWidth: 'calc(100vw - 16px)' } }}
      >
        <MenuItem
          aria-haspopup="true"
          aria-controls={knowledgeBaseAnchorEl ? 'how-to-knowledge-base-menu' : undefined}
          onMouseEnter={openKnowledgeBase}
          onClick={openKnowledgeBase}
          style={{ justifyContent: 'space-between' }}
        >
          Knowledge Base
          <ArrowRightIcon style={{ color: '#7A797A', marginLeft: '8px' }} />
        </MenuItem>
        <MenuItem
          onMouseEnter={() => setKnowledgeBaseAnchorEl(null)}
          onClick={() => {
            closeAll();
            window.location.href = 'mailto:support@centerline.co';
          }}
          style={{ whiteSpace: 'normal' }}
        >
          <span>
            Want personalized help?
            <br />
            Email us at support@centerline.co
          </span>
        </MenuItem>
      </Menu>

      {/* pointerEvents none on the popover lets the invisible backdrop pass the mouse through to
          the parent menu, so moving off "Knowledge Base" still closes the secondary menu. */}
      <Menu
        id="how-to-knowledge-base-menu"
        anchorEl={knowledgeBaseAnchorEl}
        open={Boolean(knowledgeBaseAnchorEl)}
        onClose={() => setKnowledgeBaseAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoFocus={false}
        style={{ pointerEvents: 'none' }}
        PaperProps={{ style: { pointerEvents: 'auto' } }}
        MenuListProps={{ onMouseLeave: () => setKnowledgeBaseAnchorEl(null) }}
      >
        {KNOWLEDGE_BASE_LINKS.map((link) => (
          <MenuItem key={link.url} onClick={() => handleLinkClick(link.url)}>
            {link.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
